// src/pages/ContactUsPage.js
import React from 'react';
// import Header from '../components/Header'; // Assuming Header exists
// import Footer from '../components/Footer'; // Assuming Footer exists
import ContactForm from '../components/ContactForm'; 
import PageTransition from '../components/PageTransition';

function ContactUsPage() {
  return (
    <div className="contact-us-page min-h-screen flex flex-col">
      {/* <Header /> */} 
      
      <main className="flex-grow">
        <ContactForm />
      </main>
      
      {/* <Footer /> */}
    </div>
  );
}

export default PageTransition(ContactUsPage);
